import { tmrChecklistOperationController } from 'tmr/controllers/operation/checklistOperation'
import './sessionTransferToZone.scss'
import templateUrl from './sessionTransferToZone.html'
import icon from './sessionTransferToZone.svg'

/**
 * TransferToZone Operation route configuration.
 *
 * @namespace routes.OperationTransferToZoneRoute
 * @type {TmrRoute}
 */
export const route = {
  name: 'operations.sessionTransferToZone',
  label: 'OPERATIONS.SESSIONTRANSFERTOZONE.TITLE',
  url: '/session-transfer-to-zone',
  resolve: {
    antenna: /*@ngInject*/ ActiveWorkstation => ActiveWorkstation.getAntennas(),
  },
  component: 'tmrOperationSessionTransferToZone',
  accessControl: [
    'Operation.perform',
    'Operation.SessionTransferToZone.perform',
  ],
  weight: 5,
  icon,
}

/**
 * TransferToZone Operation component.
 *
 * @type {ngComponent}
 * @prop {Antenna} antenna The antenna passed by the parent operations route
 */
export const tmrOperationSessionTransferToZone = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrOperationSessionTransferToZoneController',
  bindings: {
    antenna: '<',
    loggedUser: '<',
  },
}

/**
 * Controller of component {@link tmrOperationTransferToZone}.
 *
 * @type {ngController}
 */
export class tmrOperationSessionTransferToZoneController extends tmrChecklistOperationController {
  constructor(
    $state,
    debounce,
    $mdDialog,
    TmrToast,
    TmrMovementHelper,
    TmrMovementByUpcHelper,
    TmrOperationHelper,
    SessionMovement,
    MovementTransferToZone,
    Checklist,
    TmrChecklistNotFoundError,
    Session,
    SessionItem,
    TmrPromptModal,
    Zone
  ) {
    'ngInject'
    super(
      debounce,
      $mdDialog,
      TmrToast,
      TmrMovementHelper,
      TmrMovementByUpcHelper,
      TmrOperationHelper,
      Checklist,
      TmrChecklistNotFoundError
    )
    Object.assign(this, {
      $state,
      SessionItem,
      SessionMovement,
      MovementTransferToZone,
      Session,
      TmrPromptModal,
      Zone,
    })
  }

  initVars() {
    super.initVars()
    this.sessionChecklistEnable = false
    this.parcelCounter = 0
    this.sessionDetected = 0
    this.selectSessionDisabled = false
    this.description = null
    this.packageCode = null
    this.checklist = null
    this.sessionMovementEmpty = this.SessionMovement.create({ code: null })
    this.sessionMovementCode = null
    this.sessionMovementCodeInvalid = false
    this.sessionItemsValid = []
    this.sessionItemsInvalid = []
    this.checklistCounter = 0
  }

  getSessions(value) {
    return this.Session.filteredSearch({ value }).$promise
  }

  onChangeSession() {
    if (this.session) {
      this.onSessionSelected()
    } else {
      this.parcelCounter = 0
      this.sessionDetected = 0
    }
    this.onClear()
  }

  /**
   * Item read event, fired by tmrAntennaControls.
   * Performs MovementTransferToZone.status requests in sequence.
   */
  onItemRead() {
    this.detailsPromise
      .then(() => {
        this.loadingStatus = true
        let epcs = []
        this.antenna.$items.forEach(i => epcs.push(i.epc))
        const params = {
          id: this.session.id,
          epcs: epcs,
        }
        this.Session.itemStatus(params).$promise.then(res => {
          epcs.forEach(epc => {
            if (
              !this.sessionItemsValid.includes(epc) &&
              !this.sessionItemsInvalid.includes(epc)
            ) {
              if (res[epc] == 'VALID') {
                this.sessionItemsValid.push(epc)
              } else {
                this.sessionItemsInvalid.push(epc)
              }
            }
            this
          })

          let validItems = this.antenna.$items.filter(item => {
            return this.sessionItemsValid.includes(item.epc)
          })

          if (validItems.length > 0) {
            return this.MovementTransferToZone.status(
              this.zone,
              validItems,
              this.description,
              this.packageCode,
              this.checklist
            ).$promise.then(
              details => this.buildGroupsDebounce(details),
              err =>
                this.TmrMovementHelper.statusError(
                  err,
                  this.antenna,
                  this.onClear
                )
            )
          }
        })
      })
      .finally(() => (this.loadingStatus = false))
  }

  // Confirm SessionMovement
  onConfirm(targetEvent) {
    this.antenna.$stop()

    let sessionItems = []

    this.groupedItems.forEach(element => {
      for (let i = 0; i < element.epcs.length; i++) {
        let item = {}
        item.epc = element.epcs[i]
        item.upc = element.upc
        item.uri = element.item.uri
        item.checkDigit = element.item.checkDigit
        item.companyPrefix = element.item.companyPrefix
        item.itemReference = element.item.itemReference
        item.serial = element.item.serial
        item.product = element.item.$product

        sessionItems.push(item)
      }
    })

    const params = {
      code: this.sessionMovementCode,
      session: this.session,
      items: sessionItems,
      sessionMovementType: 'TRANSFER_TO_ZONE',
      destinationZone: this.zone,
    }

    this.SessionMovement.createSessionMovement(params)
      .$promise.then(
        this.onDetectedClear(),
        this.TmrToast.success(
          'OPERATIONS.SESSIONTRANSFERTOZONE.SESSIONMOVEMENTSUCCESS',
          'messageformat'
        ),
        this.onCallBackConfirm(targetEvent)
      )
      .catch(err => this.TmrToast.exception(err))
  }

  // callback after sessionMovement confirmed
  onCallBackConfirm(targetEvent) {
    this.$mdDialog
      .show(
        this.$mdDialog.tmrSessionTransferToZone({
          targetEvent,
          locals: { parcel: this.parcel },
        })
      )
      .then(res => {
        if (res === 'remain') {
          this.onCallBackRemain()
        } else if (res === 'change') {
          this.$state.go(this.$state.current, null, {
            reload: true,
            inherit: false,
          })
        } else if (res === 'close') {
          this.closeSession()
        } else {
          this.onCallBackRemain()
        }
      })
      .finally(() => (this.confirming = false))
  }

  // Callback from dialog to create new session
  createNewSession(targetEvent) {
    this.$mdDialog
      .show(
        this.$mdDialog.tmrNewSessionTransferToZone({
          targetEvent,
          locals: {
            sessionCode: this.sessionText,
            loggedUser: this.loggedUser,
          },
        })
      )
      .then(res => {
        this.session = res
        this.zone = res.destinationZone
        // if checklist exists should match it
      })
  }

  // Callback from selected previous session
  onSessionSelected() {
    this.zone = this.session.destinationZone
    this.SessionMovement.count({
      'session.id': this.session.id,
    }).then(res => (this.parcelCounter = res))
    this.SessionItem.count({
      'sessionMovement.session.id': this.session.id,
    }).then(res => (this.sessionDetected = res))
  }

  // Callback to remain in session
  onCallBackRemain() {
    this.onSessionSelected()
    this.onClear()
  }

  onDetectedClear() {
    this.antenna.$clearEpcs()
    this.groupedItems = []
    this.sessionItemsValid = []
    this.sessionItemsInvalid = []
  }

  // Close Session
  askCloseSession($event) {
    this.TmrPromptModal($event, {
      question: 'OPERATIONS.SESSION.CLOSEQUESTION',
      yesCallback: () => this.closeSession(),
      relativeTo: `.close-session-btn`,
    })
  }

  // Close Session action
  closeSession() {
    this.Session.close({
      id: this.session.id,
    })
      .$promise.then(res => {
        if (res) this.closeSessionSuccess()
      })
      .catch(err => this.TmrToast.exception(err))
  }

  // session closed successfully
  closeSessionSuccess() {
    this.TmrToast.success(
      'OPERATIONS.SESSION.SUCCESS',
      { COUNT: this.antenna.$items.length },
      'messageformat'
    )
    this.$state.go(this.$state.current, null, { reload: true, inherit: false })
  }

  onSessionMovementCodeChange() {
    this.SessionMovement.count({
      code: this.sessionMovementCode,
      'session.id': this.session.id,
    }).then(
      res =>
        (this.sessionMovementCodeInvalid = this.sessionMovementCode
          ? res > 0
          : false)
    )
  }

  onSessionChecklistChange(isOn, onValue) {
    this.packageCode = onValue
    super.onChecklistChange(isOn)
  }

  getZones(value) {
    return this.Zone.search({ value }).$promise.then(zones =>
      zones.filter(zone => zone.place.id != this.loggedUser.place.id)
    )
  }

  parcelDetails(targetEvent) {
    this.$mdDialog
      .show(
        this.$mdDialog.tmrSessionMovementTransferToZone({
          targetEvent,
          locals: { session: this.session },
        })
      )
      .then(() => this.onSessionSelected())
  }
}
